import React from 'react'
import ProductPage from '../../component/ProductSales/ProductSalesPage/ProductPage'
import FloatingContactUs from '../../component/floting_contact/FloatingContactUs'

const ProductSalePage = () => {
  return (
    <div>
      <ProductPage/>
      <FloatingContactUs />
    </div>
  )
}

export default ProductSalePage